
import { defineComponent } from "vue";
import AccountAndCurrencyPicker from "./components/AccountAndCurrencyPicker.vue";
import PathFinder from "./components/PathFinder.vue";
import { XrplClient } from "xrpl-client";

const xrpl = new XrplClient();

export default defineComponent({
  name: "App",
  computed: {
    xrpl() {
      return xrpl;
    },
  },
  methods: {
    destinationReady(ready: boolean | string) {
      console.log("dready", ready);
      this.ready.destination = !!ready;
      if (this.ready.destination) {
        [
          this.pathfindingParams.destination.account,
          this.pathfindingParams.destination.asset,
          this.pathfindingParams.destination.amount,
        ] = String(ready || "").split("|");

        this.$nextTick(() => {
          window.scrollTo(0, document.body.scrollHeight);
        });
      }
    },
    sourceReady(ready: boolean | string) {
      console.log("sready", ready);
      this.ready.source = !!ready;
      if (this.ready.source) {
        [this.pathfindingParams.source.account] = String(ready || "").split(
          "."
        );

        this.$nextTick(() => {
          window.scrollTo(0, document.body.scrollHeight);
        });
      }
    },
  },
  data() {
    return {
      ready: {
        ledger: false,
        destination: false,
        source: false,
      },
      pathfindingParams: {
        destination: {
          account: "",
          asset: "",
          amount: "",
        },
        source: {
          account: "",
        },
      },
      lastLedger: "",
      state: {},
      ledger: {},
    };
  },
  components: {
    AccountAndCurrencyPicker,
    PathFinder,
  },
  mounted() {
    this.xrpl.ready().then(() => {
      this.ready.ledger = true;
    });
    this.xrpl.on("state", (state) => {
      console.log("XRPL Node:", state.server.publicKey);
      this.state = state;
    });
    this.xrpl.on("ledger", (ledger) => {
      // console.log(ledger);
      this.ledger = ledger;
      this.lastLedger = (ledger?.validated_ledgers || "")
        .split("-")
        .reverse()[0]
        .split(",")
        .reverse()[0];
    });
  },
});
